declare const FeLibrary: {
  Alert: {
    getOrCreateInstance: (element: HTMLElement) => { 
      close: () => void; 
      dispose: () => void; 
    };
  };
};

/**
  * Adds JSInterop functions for the Blazor library to call for Alerts.
  */
export default class Alert {
  /**
   * Initializes the alert element.
   * @param {string} elementId The element ID.
   * @param {any} dotNetHelper The DotNet helper.
   */
  static initialize(elementId: string, dotNetHelper: any) {
    const alertEl = document.getElementById(elementId);
    if (alertEl == null) return;

    alertEl.addEventListener('close.fe.alert', () => {
      dotNetHelper.invokeMethodAsync('BlazorCloseAlert');
    });

    alertEl.addEventListener('closed.fe.alert', () => {
      dotNetHelper.invokeMethodAsync('BlazorClosedAlert');
    });

    FeLibrary?.Alert?.getOrCreateInstance(alertEl);
  }

  /**
   * Closes the alert.
   * @param {string} elementId The element ID.
   */
  static close(elementId: string) {
    const alertEl = document.getElementById(elementId);
    if (alertEl != null) {
      FeLibrary?.Alert?.getOrCreateInstance(alertEl)?.close();
    }
  }

  /**
   * Disposes the alert.
   * @param {string} elementId The element ID.
   */
  static dispose(elementId: string) {
    const alertEl = document.getElementById(elementId);
    if (alertEl != null) {
      FeLibrary?.Alert?.getOrCreateInstance(alertEl)?.dispose();
    }
  }
}